import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import useThemeStore from 'clientStore/useThemeStore';
import LogoFull from '../../assets/system24logo.png';
import LogoFullDark from '../../assets/system24logo-dark.png';
import LogoIcon from '../../assets/favicon-icon.png';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, openNav, sx }) => {
  const { mode } = useThemeStore();
  const logoSrc = mode === 'dark' ? LogoFullDark : LogoFull;

  const logo =
    openNav === false ? (
      <img width="50px" src={LogoIcon} alt="System 24" style={{ objectFit: 'contain' }} />
    ) : (
      <img width="100%" src={logoSrc} alt="System 24" style={{ objectFit: 'contain' }} />
    );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ p: 0, ...sx }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
  openNav: PropTypes.bool
};

export default Logo;
